module.exports = __webpack_public_path__ + "img/katarina_living_room_8.608f2214.jpg";